import React, { SVGProps } from 'react';

export const Stage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 21"
    width="20"
    height="21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y=".5" width="20" height="20" rx="10" fill="#175FFF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.705 8h.045a.25.25 0 0 1 .25.25v4.5a.25.25 0 0 1-.25.25h-.045a.5.5 0 0 1-.35-.145L13 11.5V13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1.5l1.355-1.355a.5.5 0 0 1 .35-.145ZM6.5 9.716c0 .157.112.284.25.284h.5c.138 0 .25-.127.25-.284v-.432C7.5 9.127 7.388 9 7.25 9h-.5c-.138 0-.25.127-.25.284v.432Z"
      fill="#fff"
    />
  </svg>
);
